
import { useMutation } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { QueryClient } from "@tanstack/react-query";

interface UseSupportMutationProps {
  queryClient: QueryClient;
  toast: any;
}

export const useSupportMutation = ({ queryClient, toast }: UseSupportMutationProps) => {
  return useMutation({
    mutationFn: async (reportId: number) => {
      const { data: session } = await supabase.auth.getSession();
      if (!session.session?.user) throw new Error("Vous devez être connecté pour soutenir un signalement");

      const { data, error } = await (supabase.from as any)('supports')
        .insert([
          { report_id: reportId, user_id: session.session.user.id }
        ])
        .select()
        .single();

      if (error) {
        if (error.code === '23505') {
          throw new Error("Vous avez déjà soutenu ce signalement");
        }
        throw error;
      }

      return data;
    },
    onSuccess: (_, reportId) => {
      queryClient.invalidateQueries({ queryKey: ['reports'] });
      queryClient.invalidateQueries({ queryKey: ['userSupports'] });
      queryClient.invalidateQueries({ queryKey: ['support', reportId] });
      
      queryClient.setQueryData(['reports'], (oldData: any) => {
        if (!oldData?.reports) return oldData;
        return {
          ...oldData,
          reports: oldData.reports.map((report: any) => {
            if (report.id === reportId) {
              return { ...report, supports: (report.supports || 0) + 1 };
            }
            return report;
          })
        };
      });

      toast({
        title: "Soutien ajouté",
        description: "Merci pour votre soutien !",
      });
    },
    onError: (error: Error) => {
      toast({
        title: "Erreur",
        description: error.message,
        variant: "destructive",
      });
    },
  });
};
